import { useState } from "react";
import styled, { css } from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { statuses, instance, gallerys } from "api";
import dayjs from "dayjs";
import "dayjs/locale/ko";

import { Organisms } from "Types/Components";
import { ReduxStates } from "Types";
import { Data as DataType } from "Types/Reducers";
import { actions } from "reducers/redux/data";
import { artists as artistActions } from "actions";
import { statuses as apiStatuses } from "api";

import AtomH2 from "Components/Atoms/H2";
import AtomPaper from "Components/Atoms/Paper";
import MoleculeFormText from "Components/Molecules/FormText";
import MoleculeFormSearch from "Components/Molecules/FormSearch";
import MoleculeFormDate from "Components/Molecules/FormDate";
import SearchGallery from "Components/Organisms/SearchGallery";
import SearchArtists from "Components/Organisms/SearchArtists";
import { typography } from "globalConstants";

export type PropsType = Organisms.OrganismForm2;

const Wrap = styled(AtomPaper)``;

const FormControlWrap = styled(MoleculeFormText.Wrap)``;
const DateWrap = styled.div`
   display: flex;
   flex-direction: row;
   column-gap: 10px;
   align-items: center;
`;
const Bar = styled.div`
   width: 11px;
   height: 1.5px;
   background-color: ${typography.other.color.gray[2]};
`;

const ChipWrap = styled(AtomPaper)`
   display: flex;
   align-items: center;
   flex-wrap: wrap;
   column-gap: 10px;
   row-gap: 10px;
   padding: 10px 10px;
   margin-top: 20px;
`;

const Chip = styled.div<any>`
   color: white;
   background-color: black;
   border-radius: 4px;
   padding: 5px 10px;
   font-size: 12px;
   cursor: pointer;
   &:after {
      content: " X";
   }
`;

const LabelComment = styled.span`
   color: #b1b1b1;
   font-size: 11px;
   font-weight: 500;
   letter-spacing: -0.03em;
   line-height: 16px;
   margin-left: 6px;
`;

export default function OrganismForm2(props: PropsType) {
   const data: any = useSelector((state: any) => state.data);
   const [museumSearchData, setMuseumSearchData]: any = useState([]);
   const [artistSearchData, setArtistSearchData]: any = useState([]);
   // const searchArtistsStatus = useSelector((state: any) => state.artists.search.status);
   const [artistKeyword, setArtistKeyword] = useState("");

   const dispatch = useDispatch();
   function dataOnChange(target: string, value: any) {
      dispatch({
         type: actions.set,
         payload: {
            ...data,
            [target]: value,
         },
      });
   }

   function callGallerySearch() {
      // dispatch({
      //    type: galleryActions.search.call,
      //    payload: {
      //       keyword: data.museum_name,
      //    },
      // });

      const queryString = Object.entries({ q: encodeURIComponent(data.museum_name) })
         .map((e) => e.join("="))
         .join("&");

      instance
         .get(`https://art-map.co.kr/api/admin/v2/museums/?${queryString} `)
         .then(function (res) {
            setMuseumSearchData(res.data.rows);
         })
         .catch(function (err) {
            console.log(err);
         });
   }

   function callArtistsSearch() {
      // dispatch({
      //    type: artistActions.search.call,
      //    payload: {
      //       keyword: artistKeyword,
      //    },
      // });

      const queryString = Object.entries({ q: encodeURIComponent(artistKeyword) })
         .map((e) => e.join("="))
         .join("&");

      instance
         .get(`https://art-map.co.kr/api/admin/v2/artists/?${queryString} `)
         .then(function (res) {
            setArtistSearchData(res.data.rows);
         })
         .catch(function (err) {
            console.log(err);
         });
   }

   function deleteArtist(idx: any) {
      let author_array = { ...data.author_array };
      delete author_array[idx];
      dispatch({
         type: actions.set,
         payload: {
            ...data,
            author: Object.keys(author_array)
               .map((idx) => `@${idx}`)
               .join(","),
            author_array: author_array,
         },
      });
   }

   console.log("museumSearchData", museumSearchData);

   return (
      <Wrap className={props.className} style={props.style} css={props.css}>
         <AtomH2>2. 전시회 등록</AtomH2>
         <FormControlWrap
            css={css`
               margin-top: 30px;
            `}>
            <MoleculeFormText.Label>전시명*</MoleculeFormText.Label>
            <MoleculeFormText.Text value={data.name} onChange={(ev: any) => dataOnChange("name", ev.target.value)}></MoleculeFormText.Text>
         </FormControlWrap>
         <MoleculeFormSearch.Wrap>
            <MoleculeFormSearch.Label>
               전시관* <LabelComment>(검색어를 입력하고 엔터를 입력해주세요)</LabelComment>
            </MoleculeFormSearch.Label>
            <MoleculeFormSearch.Text
               onKeyDown={(ev: any) => ev.key === "Enter" && callGallerySearch()}
               onClick={() => callGallerySearch()}
               value={data.museum_name}
               onChange={(ev: any) => dataOnChange("museum_name", ev.target.value)}></MoleculeFormSearch.Text>
         </MoleculeFormSearch.Wrap>
         {museumSearchData.length > 0 && <SearchGallery onSelect={() => setMuseumSearchData([])} data={museumSearchData}></SearchGallery>}
         <MoleculeFormDate.Wrap>
            <MoleculeFormDate.Label>전시기간*</MoleculeFormDate.Label>
            <DateWrap>
               <MoleculeFormDate.DatePicker
                  id="inputStartdate"
                  placeholderText="오픈 일"
                  selected={data.startdate && dayjs(data.startdate).toDate()}
                  onChange={(date: any) => {
                     dataOnChange("startdate", dayjs(date).format("YYYY-MM-DD"));
                  }}></MoleculeFormDate.DatePicker>
               <Bar></Bar>
               <MoleculeFormDate.DatePicker
                  id="inputEnddate"
                  placeholderText="마감 일"
                  selected={data.enddate && dayjs(data.enddate).toDate()}
                  onChange={(date: any) => {
                     dataOnChange("enddate", dayjs(date).format("YYYY-MM-DD"));
                  }}></MoleculeFormDate.DatePicker>
            </DateWrap>
         </MoleculeFormDate.Wrap>
         <FormControlWrap>
            <MoleculeFormText.Label>운영시간*</MoleculeFormText.Label>
            <MoleculeFormText.Text id="inputRuntime" value={data.runtime} onChange={(ev: any) => dataOnChange("runtime", ev.target.value)} placeholder="00:00-00:00"></MoleculeFormText.Text>
         </FormControlWrap>
         <MoleculeFormSearch.Wrap>
            <MoleculeFormSearch.Label>작가</MoleculeFormSearch.Label>
            <MoleculeFormSearch.Text
               value={artistKeyword}
               onChange={(ev: any) => setArtistKeyword(ev.target.value)}
               onClick={() => callArtistsSearch()}
               onKeyDown={(ev: any) => ev.key === "Enter" && callArtistsSearch()}
               placeholder="작가 명을 검색해 주세요"></MoleculeFormSearch.Text>
         </MoleculeFormSearch.Wrap>
         {artistSearchData.length > 0 && <SearchArtists onSelect={() => setArtistSearchData([])} data={artistSearchData}></SearchArtists>}
         {data.author && (
            <ChipWrap>
               {Object.keys(data.author_array).map((idx: any) => (
                  <Chip key={idx} onClick={() => deleteArtist(idx)}>
                     {data.author_array[idx]}
                  </Chip>
               ))}
            </ChipWrap>
         )}
         <FormControlWrap>
            <MoleculeFormText.Label>
               아트맵 미 등록 작가<LabelComment>(검색되지 않는 작가)</LabelComment>
            </MoleculeFormText.Label>
            <MoleculeFormText.Text value={data.authorplus} onChange={(ev: any) => dataOnChange("authorplus", ev.target.value)} placeholder="여러명일 경우 , 로 구분해 주세요"></MoleculeFormText.Text>
         </FormControlWrap>
         <FormControlWrap>
            <MoleculeFormText.Label>
               전시회 홈페이지<LabelComment>(없을 시 SNS 링크도 가능)</LabelComment>
            </MoleculeFormText.Label>
            <MoleculeFormText.Text value={data.exh_homepage} onChange={(ev: any) => dataOnChange("exh_homepage", ev.target.value)}></MoleculeFormText.Text>
         </FormControlWrap>
      </Wrap>
   );
}
